import styled from "styled-components";
import { Card, Chip, Box, Paper, Tabs } from "@mui/material";
import { THEME_MAP } from "../../theme";

export const TabsContainer = styled(Box)`
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  margin-bottom: 24px;
  width: 100%;
`;

export const StyledTabs = styled(Tabs)`
  min-height: 48px;
  width: 100%;

  .MuiTab-root {
    text-transform: none;
    font-weight: 500;
    font-size: 0.95rem;
    min-height: 48px;
  }

  @media (max-width: 767px) {
    .MuiTab-root {
      font-size: 0.85rem;
      padding: 6px 8px;
      min-height: 42px;
    }
  }
`;

export const Container = styled.div`
  padding: 24px;
  margin: 0 auto;
  box-sizing: border-box;
  width: 100%;
  max-width: none;

  @media (max-width: 767px) {
    padding: 16px;
  }
`;

export const TabContent = styled.div`
  overflow-x: auto;
  width: 100%;
`;

export const StyledCard = styled(Card)`
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
`;

export const StatusChip = styled(Chip)`
  margin: 4px;
`;

export const ResultContainer = styled(Box)`
  margin-top: 16px;
  padding: 16px;
  background-color: ${THEME_MAP["color-basic-100"]};
  border-radius: 8px;
  max-height: 400px;
  overflow-y: auto;
`;

export const EstablishmentCard = styled(Paper)`
  padding: 12px;
  margin: 8px 0;
  border-left: 4px solid ${THEME_MAP["color-primary-500"]};
`;

export const MobileCard = styled.div`
  background: ${THEME_MAP["color-basic-100"]};
  border: 1px solid ${THEME_MAP["color-basic-400"] || "#e0e0e0"};
  border-radius: 8px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  .card-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    padding: 4px 6px;
    border-radius: 4px;
  }

  .card-row:nth-child(even) {
    background-color: rgba(0, 0, 0, 0.06);
  }

  .card-label {
    font-size: 0.8rem;
    color: rgba(0, 0, 0, 0.55);
    flex-shrink: 0;
  }

  .card-value {
    font-size: 0.875rem;
    text-align: right;
    word-break: break-word;
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;

    strong {
      font-size: 0.95rem;
    }
  }

  .muted {
    font-size: 0.75rem;
    color: rgba(0, 0, 0, 0.5);
  }
`;
